import React, { useState } from 'react';
import { authFetch } from '../utils/apiHelper';
import { API_URL } from '../config';
import { modalPrimaryBtn, modalSecondaryBtn, MODAL_BTN_ROW } from '../modalButtons';
import ModalOverlay from './ModalOverlay';

const EXPIRATION_OPTIONS = [1, 3, 5, 10, 15, 20, 30];

const shareInputStyle = {
  width: '100%',
  padding: '9px 12px',
  borderRadius: 7,
  border: '1px solid #ddd',
  fontSize: 13,
  fontFamily: 'Inter, Arial, sans-serif',
  outline: 'none',
  boxSizing: 'border-box',
  marginBottom: 14,
  color: '#1a1a1a',
  background: '#f7f7f7',
};

const shareLabelStyle = {
  fontSize: 11,
  fontWeight: 600,
  color: '#888',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  display: 'block',
  marginBottom: 6,
};

// model: { modelId, name? }
const ShareModal = ({ model, onClose, onGenerated }) => {
  const [shareExpirationDays, setShareExpirationDays] = useState(3);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleGenerateShare = async () => {
    setSubmitting(true);
    setError('');
    try {
      const res = await authFetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ createShare: true, modelId: model.modelId, expirationDays: shareExpirationDays }),
      });
      if (!res.ok) throw new Error();
      onGenerated();
      onClose();
    } catch {
      setError('Failed to generate share link. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <ModalOverlay>
      <div
        className="modal-content"
        style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          padding: '28px 30px 24px',
          maxWidth: 380,
          width: '90%',
          pointerEvents: 'auto',
          textAlign: 'left',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <span style={{ fontSize: 16, fontWeight: 600, fontFamily: 'Inter, Arial, sans-serif', color: '#1a1a1a' }}>
            Share
          </span>
        </div>

        <label style={shareLabelStyle}>Expiration (days)</label>
        <select
          value={shareExpirationDays}
          onChange={(e) => setShareExpirationDays(Number(e.target.value))}
          style={{ ...shareInputStyle, marginBottom: 8, cursor: 'pointer' }}
        >
          {EXPIRATION_OPTIONS.map((days) => (
            <option key={days} value={days}>{days} day{days === 1 ? '' : 's'}</option>
          ))}
        </select>

        <p style={{ fontSize: 12, color: '#888', margin: '0 0 8px', fontFamily: 'Inter, Arial, sans-serif' }}>
          Expires on {new Date(Date.now() + shareExpirationDays * 24 * 60 * 60 * 1000).toLocaleString(undefined, {
            dateStyle: 'medium',
            timeStyle: 'short',
          })}
        </p>

        <p style={{ fontSize: 12, color: '#888', margin: '0 0 20px', fontFamily: 'Inter, Arial, sans-serif' }}>
          Find the generated link under Shares in the settings menu.
        </p>

        {error && <p style={{ color: '#ef4444', fontSize: 13, margin: '0 0 14px', fontFamily: 'Inter, Arial, sans-serif' }}>{error}</p>}

        <div style={MODAL_BTN_ROW}>
          <button type="button" onClick={onClose} disabled={submitting} style={{ ...modalSecondaryBtn, flex: 1 }}>
            Cancel
          </button>
          <button
            type="button"
            onClick={handleGenerateShare}
            disabled={submitting}
            style={{ ...modalPrimaryBtn, flex: 1, cursor: submitting ? 'default' : 'pointer', opacity: submitting ? 0.7 : 1 }}
          >
            {submitting ? 'Creating…' : 'Create link'}
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default ShareModal;
